import styles from "./point-on-map-modal.module.css";
import { useEffect, useMemo } from "react";
import { Input, Form, Modal, Flex } from "antd";

import InputPointOnMap from "@/components/inputs/InputPointOnMap";

import {
  COORDINATE_RULE,
  LATITUDE_RULE,
  LONGITUDE_RULE,
  isValidCoordinate,
} from "@/constants/map";

// import { Button, Tooltip } from "antd";
// import CheckIcon from "@/icons/CheckIcon";
// import DuplicateIcon from "@/icons/DuplicateIcon";
// import ReplyIcon from "@/icons/ReplyIcon";

// import { useUndoPoints } from "@/hooks/useUndoPoints";
// import { useCopySelectedPoints } from "@/hooks/useCopySelectedPoints";
// import TrashIcon from "@/icons/TrashIcon";

const MODAL_WIDTH = 1000;
const FORM_WIDTH = 350;

// function parseClipboardNumbers(text) {
//   if (!text) return [];

//   return text
//     .trim()
//     .split(/[\n\t,; ]+/)
//     .map((v) => parseFloat(v.replace(",", ".")))
//     .filter((v) => !Number.isNaN(v));
// }

// Окно для установки точки на карте, содержит интерактивную карту и форму с координатами
const PointOnMapModal = ({
  field,
  data,
  visible,
  onSave,
  onCancel,
  color,
  objectUuid,
}) => {
  const [form] = Form.useForm();

  // const setPoint = (points) => {
  //   const point = points?.[0] ?? { lat: null, lon: null };
  //   form.setFieldsValue(point);
  // };

  // const { undo, canUndo, init, commit } = useUndoPoints({
  //   setPoints: setPoint,
  // });

  useEffect(() => {
    if (!data) {
      const empty = { lat: null, lon: null };
      form.setFieldsValue(empty);
      // init([empty]);
      return;
    }

    // Поддерживаем оба формата: {x, y} и {lat, lon}
    const lat = data.lat ?? data.x ?? null;
    const lon = data.lon ?? data.y ?? null;

    const point = { lat, lon };

    form.setFieldsValue(point);
    // init([point]);
  }, [data, form]);

  // Получаем текущие значения формы
  const formValues = Form.useWatch([], form);

  // Мемоизируем точку для передачи в InputMap
  const currentPoint = useMemo(() => {
    if (formValues?.lat && formValues?.lon) {
      const lat = parseFloat(formValues.lat);
      const lon = parseFloat(formValues.lon);
      // Проверяем, что координаты валидны и в диапазоне
      if (
        isValidCoordinate(formValues.lat, -90, 90) &&
        isValidCoordinate(formValues.lon, -180, 180)
      ) {
        return { lat, lon };
      }
    }
    return data || null;
  }, [formValues, data]);

  // Обработчик изменения точки на карте
  const handleChangePoint = (point) => {
    if (point?.lat && point?.lon) {
      form.setFieldsValue({
        lat: point.lat,
        lon: point.lon,
      });
      // commit([point]);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const handleSave = async (values) => {
    onSave(values);
    form.resetFields();
  };

  // Копирование точки
  // const pointAsArray = useMemo(() => {
  //   const lat = formValues?.lat;
  //   const lon = formValues?.lon;

  //   if (isValidCoordinate(lat, -90, 90) && isValidCoordinate(lon, -180, 180)) {
  //     return [{ lat, lon }];
  //   }

  //   return [];
  // }, [formValues]);

  // const selectedPoints = useMemo(() => {
  //   return pointAsArray.length ? new Set([0]) : new Set();
  // }, [pointAsArray]);

  // const { copied, copy } = useCopySelectedPoints({
  //   selectedPoints,
  //   points: pointAsArray,
  // });

  // Вставка значений
  // const handlePaste = (e) => {
  //   const text = e.clipboardData?.getData("text");
  //   if (!text) return;

  //   const numbers = parseClipboardNumbers(text);

  //   if (numbers.length <= 1) return;

  //   e.preventDefault();

  //   const [lat, lon] = numbers;

  //   const next = {
  //     lat,
  //     lon,
  //   };

  //   form.setFieldsValue(next);
  //   commit([next]);
  // };

  const onOk = () => {
    form
      .validateFields()
      .then((values) => {
        const normalized = {
          lat: Number(values.lat),
          lon: Number(values.lon),
        };

        handleSave(normalized);
      })
      .catch((info) => {
        console.log("Ошибка валидации:", info);
      });
  };

  return (
    <Modal
      className={styles.point_modal}
      maskClosable={false}
      title="Управление точкой на карте"
      open={visible}
      onOk={onOk}
      onCancel={handleCancel}
      okText="Сохранить"
      cancelText="Отмена"
      width={MODAL_WIDTH}
      cancelButtonProps={{ tabIndex: -1 }}
    >
      <Flex gap={20} className={styles.point_modal_content}>
        <div className={styles.point_map}>
          <InputPointOnMap
            field={field}
            value={currentPoint}
            onChange={handleChangePoint}
            color={color}
            objectUuid={objectUuid}
            style={{ height: "100%" }}
          />
        </div>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSave}
          className={styles.point_form}
          style={{ "--point-form-width": `${FORM_WIDTH}px` }}
          onFieldsChange={(changedFields) => {
            if (!changedFields.length) return;

            // const lat = form.getFieldValue("lat");
            // const lon = form.getFieldValue("lon");

            // if (lat !== undefined && lon !== undefined) {
            //   commit([{ lat, lon }]);
            // }
          }}
        >
          {/* <Flex justify="flex-end" gap={8} style={{ marginBottom: 8 }}>
            <Tooltip title={copied ? "Скопировано" : "Копировать координаты"}>
              <Button
                type="default"
                icon={copied ? <CheckIcon /> : <DuplicateIcon />}
                disabled={!pointAsArray.length}
                onClick={copy}
                className={styles.point_action_btn}
              />
            </Tooltip>

            <Tooltip title="Очистить координаты">
              <Button
                danger
                type="default"
                icon={<TrashIcon />}
                onClick={() => {
                  const empty = { lat: null, lon: null };
                  form.setFieldsValue(empty);
                  commit([empty]);
                }}
                className={styles.point_action_btn}
              />
            </Tooltip>

            <Tooltip title="Отменить последнее действие">
              <Button
                type="default"
                icon={<ReplyIcon />}
                disabled={!canUndo}
                onClick={undo}
                className={styles.point_action_btn}
              />
            </Tooltip>
          </Flex> */}

          <Form.Item
            autoFocus
            label="Широта"
            name="lat"
            rules={[
              { required: true, message: "Введите широту" },
              COORDINATE_RULE,
              LATITUDE_RULE,
            ]}
          >
            <Input placeholder="Например: 55.7558" />
          </Form.Item>

          <Form.Item
            label="Долгота"
            name="lon"
            rules={[
              { required: true, message: "Введите долготу" },
              COORDINATE_RULE,
              LONGITUDE_RULE,
            ]}
          >
            <Input placeholder="Например: 37.6173" />
          </Form.Item>
        </Form>
      </Flex>
    </Modal>
  );
};

export default PointOnMapModal;
